import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

const Intro = ({ r, onSaved }) => {
  const [text, setText] = useState(r.intro);
  const [busy, setBusy] = useState(false);
  const slug = r.region.toLowerCase().replace(/[^a-z]+/g, "-");
  const save = async () => {
    setBusy(true);
    try { await api.put(`/regions/${encodeURIComponent(r.region)}`, { intro: text }); toast.success(`${r.region} intro saved — your shop picks it up within 10 minutes`); onSaved(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid={`region-intro-${slug}`} className="space-y-2">
      <div className="flex items-baseline justify-between">
        <h3 className="font-display text-xl text-[#3B1B48]">{r.region}</h3>
        {r.updated_at && <span className="text-xs text-[#8C827A]">Saved {new Date(r.updated_at).toLocaleDateString("en-AU")}</span>}
      </div>
      <Textarea data-testid={`region-intro-input-${slug}`} rows={4} value={text} onChange={(e) => setText(e.target.value)} placeholder={`A warm paragraph introducing ${r.region} for your shop's region page`} className="bg-white rounded-none text-sm" />
      <Button size="sm" data-testid={`region-intro-save-${slug}`} onClick={save} disabled={busy || text.trim().length < 20 || text === r.intro} className="rounded-none">{busy ? "Saving…" : "Save intro"}</Button>
    </div>
  );
};

export const RegionIntros = () => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/regions").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  if (!rows.length) return null;
  return (
    <div data-testid="region-intros" className="border border-[#E2D9CC] bg-[#F4EFE6] p-7 space-y-6">
      <div>
        <h2 className="font-display text-2xl text-[#3B1B48]">Region intros</h2>
        <p className="text-sm text-[#8C827A] mt-1">Shown at the top of each region page in your shop. Sent in the product list (<code>region_intro</code>), the packs list and /api/public/regions.</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">{rows.map((r) => <Intro key={r.region} r={r} onSaved={load} />)}</div>
    </div>
  );
};
